import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  debounce,
  get,
  noop,
} from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import OutsideClickHandler from 'react-outside-click-handler';

import immutableToJS from 'helpers/immutableToJS';
import { dispatchRestMaker } from 'helpers/utils';
import {
  injectIntl,
  DropdownItems,
} from 'components';
import { FRInput } from 'elements';
import accountActions from 'redux/accounts/actions';
import { selectState } from 'redux/selectors';

const styles = () => ({
  labelAsterisk: { color: 'red' },
});

export class AutoFill extends Component {
  static contextTypes = {
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
    isRestaurant: PropTypes.bool,
    isConsumer: PropTypes.bool,
  };

  static propTypes = {
    accounts: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    })).isRequired,
    classes: PropTypes.shape({}).isRequired,
    accountsRequesting: PropTypes.bool,
    email: PropTypes.string,
    isVendor: PropTypes.bool,

    clearInfo: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    listAccounts: PropTypes.func.isRequired,
    onSelect: PropTypes.func,
  };

  static defaultProps = {
    accountsRequesting: false,
    email: '',
    isVendor: false,
    onSelect: noop,
  };

  state = { showItems: false };

  componentDidMount() {
    this._ismounted = true;
  }

  componentWillReceiveProps(newProps) {
    if (this.props.email !== newProps.email && newProps.email !== this.emailInput.value) {
      // this.onChangeSearchText(newProps.email);
    }
  }

  componentWillUnmount() {
    this._ismounted = false;
  }

  onBlur = () => {
    setTimeout(() => {
      if (this._ismounted) {
        this.setState({ showItems: false });
        const { accounts, email, onSelect } = this.props;
        const account = accounts.find(info => info.email === email);
        if (account) {
          onSelect(account);
        }
      }
    }, 1000);
  }

  onChangeSearchText = (value) => {
    const { clearInfo } = this.props;
    clearInfo(value);

    if (value.length < 3) return;
    this.handleListAccounts();
  };

  onClick = (item) => {
    const { onSelect } = this.props;

    this.setState({ showItems: false });
    onSelect(item);
  };

  onClickForTextField = () => {
    this.setState({ showItems: true });
  };

  getFilteredAccounts = (accounts) => {
    const { isConsumer, isRestaurant, isFarmer, isDistributor } = this.context;
    const { isVendor } = this.props;
    let filteredAccounts = accounts;
    if (isDistributor) {
      if (isVendor) {
        filteredAccounts = accounts.filter(account => get(account, 'role.name') === 'Seller');
      } else {
        filteredAccounts = accounts.filter(account => get(account, 'role.name') === 'Buyer');
      }
    } else if (isFarmer) {
      filteredAccounts = accounts.filter(account => get(account, 'role.name') === 'Consumer' || get(account, 'role.name') === 'Buyer' || get(account, 'role.name') === 'Distributor');
    } else if (isRestaurant) {
      filteredAccounts = accounts.filter(account => get(account, 'role.name') === 'Seller' || get(account, 'role.name') === 'Distributor');
    } else if (isConsumer) {
      filteredAccounts = accounts.filter(account => get(account, 'role.name') === 'Seller');
    }

    return filteredAccounts;
  };

  getOptions = () => {
    const { accounts } = this.props;
    const { showItems } = this.state;
    const filteredAccounts = this.getFilteredAccounts(accounts);
    const itemMapped = filteredAccounts.map(item => ({
      id: item.id,
      primaryText: (
        <div className="accounts">
          <div className="item-email">
            {item.email}
          </div>
          <div className="item-name-company">
            <div className="item-name">
              {get(item, 'profile.firstName')} {get(item, 'profile.lastName')}
            </div>
            <div>
              <strong>{get(item, 'profile.companyName')}</strong>
            </div>
          </div>
        </div>
      ),
      onClick: () => this.onClick(item),
    }));

    return showItems ? itemMapped : [];
  };

  listAccounts = () => {
    const { email, listAccounts } = this.props;

    listAccounts({
      limit: 25,
      search: email,
      searchFields: 'email profile->>\'companyName\'',
      // disallowDistToDist: true,
    });

    this.setState({ showItems: true });
  }

  handleListAccounts = debounce(this.listAccounts, 300);

  render() {
    const {
      accountsRequesting,
      email,
      formatMessage,
      classes,
    } = this.props;

    const searchedItems = (
      <DropdownItems
        loading={accountsRequesting}
        options={this.getOptions()}
      />
    );

    return (
      <div className="search-accounts">
        <OutsideClickHandler onOutsideClick={this.onBlur}>
          <FRInput
            InputLabelProps={{
              shrink: true,
              FormLabelClasses: {
                asterisk: classes.labelAsterisk,
              },
            }}
            autoComplete="off"
            fullWidth
            inputRef={(ref) => { this.emailInput = ref; }}
            label={formatMessage('Email')}
            name="autofill_email"
            onChange={event => this.onChangeSearchText(event.target.value)}
            onClick={this.onClickForTextField}
            required
            value={email}
            variant="outlined"
          />
          {searchedItems}
        </OutsideClickHandler>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('accounts', 'accounts')(state, 'accounts'),
});

export default compose(
  setDisplayName('AutoFill'),
  connect(
    mapStateToProps,
    dispatchRestMaker([
      [accountActions, 'account'],
    ]),
  ),
  immutableToJS,
  injectIntl,
  withStyles(styles),
)(AutoFill);
